import React from 'react';
import { Typography, useMediaQuery } from 'fronton-react';
import { TCalculateData } from 'pages/dimensions/store/dimensions';
import { useTranslation } from 'react-i18next';

const DATA_TEST_ID = 'configuration-additional-info';

const Info = ({ title }: { title: string }) => {
  const isMobile = useMediaQuery({
    maxWidth: 767,
  });

  if (isMobile) {
    return (
      <Typography size="caption" variant="minor" color="text-primary" data-testid={DATA_TEST_ID}>
        {title}
      </Typography>
    );
  }

  return (
    <Typography size="body_long" variant="s" color="text-primary" data-testid={DATA_TEST_ID}>
      {title}
    </Typography>
  );
};

export const AdditionalInfo = ({ surface, inputParameters }: Partial<TCalculateData>) => {
  const { t } = useTranslation();
  if (surface?.FLOOR?.typeInstallation) {
    return (
      <Info
        title={`${t('calculator.calculation.additionalInfo.layingType')}: ${
          surface?.FLOOR?.typeInstallation
        }`}
      />
    );
  }

  if (inputParameters?.layerThickness) {
    return (
      <Info
        title={`${t('calculator.calculation.additionalInfo.layerThickness')}: ${
          inputParameters?.layerThickness
        } мм`}
      />
    );
  }

  if (inputParameters?.height) {
    return (
      <Info
        title={`${t('calculator.calculation.additionalInfo.ceilingHeight')}: ${inputParameters?.height} м`}
      />
    );
  }

  return null;
};
